import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import {  LocalStorageService } from 'src/app/utils/LocalStorageService';
import { AuthService } from '../services/auth.service';
import { JWTTokenServiceService } from '../services/token.service';
import { ToastrService } from 'ngx-toastr';
import { AmcService } from '../../private/services/amc.service'

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  isPasswordVisible = false;
  userName: any;
  btnLoading:boolean = false;
  form: FormGroup = new FormGroup({
    username: new FormControl(''),
    password: new FormControl(''),
  });
  submitted = false;
  isLoading = false;
  buttonTitle = "Login"
  otpForm:boolean = false;
  userOTP:any;
  loginData:any;
  constructor(private toastr: ToastrService,private localStorageService:LocalStorageService, private jwt:JWTTokenServiceService, private coreAuth:AuthService,private router: Router, private formBuilder: FormBuilder,private api:AmcService) { }
  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.onEnter();
    }
  }

  onEnter() {
    // Handle Enter key press here
    // console.log('Enter key pressed');
    // this.onSubmit()
    if(this.otpForm)
    {
      this.onOTPLogin();
    }else
    {
      this.onSubmit();
    }
  }
  ngOnInit(): void {
    this.form = this.formBuilder.group(
      {
        username: ['',[Validators.required, Validators.minLength(4), Validators.maxLength(20)]],
        password: ['',[Validators.required,Validators.minLength(6),Validators.maxLength(40)]],
      }
    );
  }


   forgetPassword(){
    this.router.navigate(['forget-password']);
  }
  goToDashboard(){
    this.router.navigate(['dashboard/home']);
  }


  get formError(): any {
    return this.form.controls;
  }
  onOTPLogin()
  {
    this.submitted = true;
    this.isLoading = true;
    this.buttonTitle = "Loading"
    let param = {
      user_id:this.loginData.user_id,
      otp:this.userOTP,
      token:this.loginData.token
  
    }
    this.coreAuth.verifyOtp(param).subscribe({
      next: (res) => {
        if(res)
        {
          this.buttonTitle = "Login"
          this.isLoading = false;
          this.jwt.setToken(res.token);
          this.toastr.success('Login Successful', 'Welcome');
          this.localStorageService.login(res);
          this.router.navigate(['main/appointments']);
        
        }
  
      },
      error: (e) => {
        this.buttonTitle = "Login"
        this.isLoading = false;
      },
      complete: () => {
        this.buttonTitle = "Login"
        this.isLoading = false;
      }
  }) 
  }
  onSubmit(): void {
    this.submitted = true;
    if (this.form.invalid) {
      console.log('Form is invalid. Displaying error messages.'); 
      console.log('Username Errors:', this.form.controls['username'].errors);
      console.log('Password Errors:', this.form.controls['password'].errors);
      return;
    }
   this.isLoading = true;
   this.buttonTitle = "Loading"
   this.coreAuth.loginUser(this.form.value).subscribe({
    next: (res) => {
      console.log("hosp : ",res)
      this.convertImageUrlToBase64(res.hospital.logo, (base64:any) =>{
        localStorage.setItem("logo_base64",base64);
    });
     
      if(res)
      {
        if(res.twoFactorAuthentication)
        {
          this.otpForm = true;
          this.loginData = res;
        }
        else
        {
          // this.checkAmc(res.hospital_id);
          this.buttonTitle = "Login"
          this.isLoading = false;
          this.jwt.setToken(res.token);
          this.toastr.success('Login Successful', 'Welcome');
          this.localStorageService.login(res);
          this.router.navigate(['main/appointments']);
        }
      
      }

    },
    error: (e) => {
      this.buttonTitle = "Login"
      this.isLoading = false;
      this.toastr.error('Login Failed', 'Error');
    },
    complete: () => {
      this.buttonTitle = "Login"
      this.isLoading = false;
    }
}) 
  }
  forgetPass()
  {
     this.router.navigate(['forget']);
  }

  togglePasswordVisibility(): void {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  async checkAmc(hospital_id:any) {
    let param = {
        "hospital_id": hospital_id
    }
    this.api.getAMCStatus(param).subscribe({
      next:(response)=>{
         console.log(response);
      },
      error:(e)=>{

      }
    })
  }

  async convertImageUrlToBase64(imageUrl:any, callback:any) {
    const img = new Image();
    img.crossOrigin = "Anonymous"; // Prevents CORS issues
    img.src = imageUrl;

    img.onload = function () {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx:any = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        const base64String = canvas.toDataURL("image/png"); // Convert to Base64
        callback(base64String);
    };

    img.onerror = function () {
        console.error("Error loading image");
        callback(null);
    };
}

}
